"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerMutationOptions = exports.registerMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../fragments/meUser");
const me_1 = require("../queries/me");
exports.registerMutation = client_1.gql `
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      __typename
      errors {
        path
        message
      }
      user {
        ...meUser
      }
      cookbookId
      sectionId
    }
  }

  ${meUser_1.meUserFragment}
`;
exports.registerMutationOptions = (variables) => ({
    variables,
    update: (cache, { data }) => {
        try {
            if (!data || !data.register.user) {
                return;
            }
            cache.writeQuery({
                query: me_1.meQuery,
                data: {
                    __typename: "Query",
                    me: {
                        __typename: "UserResponse",
                        user: Object.assign({}, data.register.user),
                    },
                },
            });
        }
        catch (_a) { }
    },
});
//# sourceMappingURL=Register.js.map